import React from 'react';
import PropTypes from 'prop-types';

import useProductCustomerPhotosReviewsMin from 'data-hooks/useProductCustomerPhotosReviews/useProductCustomerPhotosReviewsMin';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import getRoundedRating from 'commons/getRoundedRating';
import PDPNameSectionUI from './PDPNameSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPNameSectionPlaceholder from './PDPNameSectionPlaceholder';

const PDPNameSectionInner = ({ isEditOrder = false }) => {
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const { loading, error, data } = usePDPBasicDetails();

  const {
    loading: customerPhotosReviewsLoading,
    data: customerPhotosReviewsData,
  } = useProductCustomerPhotosReviewsMin();

  const { data: optionsData } = usePDPOptions();

  if ((!data && loading) || !optionsData) {
    return <PDPNameSectionUI loading />;
  }

  if (error) {
    return 'Something went wrong, please try again';
  }

  const { name = '', meta: { reviews } = {} } = data ?? {};

  const subtitle = data?.attributes?.filter(
    item => item.code === 'product_subtitle'
  )[0]?.value;

  const {
    customer_photos_min: { totalPhotos } = {},
    customer_reviews: { totalReviews } = {},
  } = customerPhotosReviewsData || {};

  const roundedRating = getRoundedRating(reviews?.average_score);

  const finalName = pdpIsModularBYOProduct
    ? `Build your own ${name.replace(/ modular$/i, '')}`
    : name;

  return (
    <PDPNameSectionUI
      name={finalName}
      subtitle={subtitle}
      loading={false}
      reviewsLoading={
        !customerPhotosReviewsData && customerPhotosReviewsLoading
      }
      rating={roundedRating}
      isEditOrder={isEditOrder}
      numberOfReviews={(totalPhotos || 0) + (totalReviews || 0)}
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
    />
  );
};

PDPNameSectionInner.propTypes = {
  isEditOrder: PropTypes.bool,
};

const PDPNameSection = props => (
  <SuspenseWithLoader fallback={<PDPNameSectionPlaceholder />}>
    <PDPNameSectionInner {...props} />
  </SuspenseWithLoader>
);

export default PDPNameSection;
